import View from '@/views';

const BlankLayout = () => {
	return (
		<div className="app-layout-blank flex flex-auto flex-col">
			<View />
		</div>
	);
};

export default BlankLayout;
